<template>
  <div class="datetime-picker">
    <v-text-field
      :value="displayValue"
      @input="$emit('input', $event)"
      hide-details="auto"
      :rounded="rounded"
      outlined
      :placeholder="placeholder"
    >
      <template v-slot:append>
        <v-btn
          v-if="displayValue && displayValue.length"
          icon
          @click="$emit('input', null)"
        >
          <v-icon>$close</v-icon>
        </v-btn>
        <v-menu
          v-model="opened"
          :content-class="`datetime-picker__menu ${
            openedDt ? 'datetime-picker__menu--visible' : ''
          }`"
        >
          <template v-slot:activator="{ on }">
            <v-btn class="datetime-picker__picker" icon v-on="on">
              <v-icon>$calendar</v-icon>
            </v-btn>
          </template>
          <VueCtkDateTimePicker
            v-if="openedDt"
            inline
            :value="displayValue"
            locale="en"
            @input="setDate"
            @close="close"
            color="#EE3624"
            button-color="#EE3624"
            :timezone="currentUser.active_project.timezone"
          >
          </VueCtkDateTimePicker>
        </v-menu>
      </template>
      <template v-slot:prepend-inner>
        <div :style="{ background: value }" class="datetime-picker__box"></div>
      </template>
    </v-text-field>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "./VueCtkDateTimePicker/index";

export default {
  components: { VueCtkDateTimePicker },
  props: {
    placeholder: String,
    label: String,
    value: [String, Date],
    rounded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      displayValue: "",
      opened: false,
      openedDt: false,
    };
  },
  methods: {
    setDate($event) {
      const momentDate = this.$moment.tz(
        $event,
        "YYYY-MM-DD h:mm A",
        this.currentUser.active_project.timezone
      );
      this.$emit("input", momentDate.toDate());
      this.displayValue = $event;
    },
    close() {
      this.opened = false;
    },
  },
  watch: {
    value: {
      handler() {
        if (this.value) {
          const momentDate = this.$moment.tz(
            this.value,
            this.currentUser.active_project.timezone
          );

          this.displayValue = momentDate.format("YYYY-MM-DD h:mm A");
        } else {
          this.displayValue = "";
        }
      },
      immediate: true,
    },
    opened() {
      setTimeout(() => (this.openedDt = this.opened), 50);
    },
  },
};
</script>

<style scoped lang="scss">
.datetime-picker {
  width: 270px;

  &__menu {
    width: 420px;
    visibility: hidden;

    &--visible {
      visibility: visible;
    }
  }

  &::v-deep {
    fieldset {
      border-color: var(--v-border-base);
    }

    .v-input__slot:hover fieldset {
      border-color: rgba(0, 0, 0, 0.3);
    }

    .v-input__append-inner {
      margin-top: 11px;
    }
    .v-input__slot {
      padding-right: 10px;
    }

    .time-picker {
      max-width: 160px;
    }
  }
}
</style>
